import { useSelector } from 'react-redux';
import { DefaultMapEntity } from '../types';

const useMapInfo = () => {
  const compounds = useSelector((state: any) => state.map.compounds);
  const areas = useSelector((state: any) => state.map.areas);
  const resultsType = useSelector((state: any) => state.map.resultsType);
  const results = resultsType == 'areas' ? areas : compounds;
  const resultType = resultsType == 'areas' ? 'area' : 'compound';

  const interactiveLayerIds = results?.map(
    (result: DefaultMapEntity) => `${resultType}-fill-${result.id}`
  );
  return { interactiveLayerIds };
};

export default useMapInfo;
